module.exports = {"440513001":"文光街道","440513002":"棉北街道","440513003":"城南街道","440513004":"金浦街道","440513100":"海门镇","440513101":"河溪镇","440513102":"和平镇","440513103":"西胪镇","440513104":"关埠镇","440513106":"谷饶镇","440513107":"贵屿镇","440513108":"铜盂镇","440513110":"金灶镇"}


//////////////////
// WEBPACK FOOTER
// ./src/town/440513.json
// module id = 2107
// module chunks = 0